import type { ChangeObservable } from "common/change-obserable";
import * as React from "react";

export function useChangeObservable<T>(observable: ChangeObservable<T>): T;
export function useChangeObservable<T>(observable: ChangeObservable<T> | undefined): T | undefined;
export function useChangeObservable<T>(observable: ChangeObservable<T> | undefined): T | undefined {
    const [result, setResult] = React.useState(observable?.current);

    const resultRef = React.useRef(result);
    resultRef.current = result;

    // isFirst check is to ensure we don't double render the first time useChangeObservable is called
    const isFirst = React.useRef(true);
    React.useEffect(() => {
        // unfortunately the observable may have changed between the first call and now so we need to check
        if (!isFirst.current || resultRef.current !== observable?.current) {
            setResult(observable?.current);
        }

        isFirst.current = false;

        if (observable === undefined) return undefined;

        const cb = (newValue: T) => {
            setResult(newValue);
        };
        observable.subscribe(cb);
        return () => observable.unsubscribe(cb);
    }, [observable]);
    return result;
}
